<template>
  <div>
    <div class="home">
      <van-nav-bar title="加入我们" left-text="返回" @click-left="onClickLeft"/>
      <van-field required label="申请单位" v-model="company" placeholder="请输入申请单位" />
      <van-field required label="联系人" v-model="person" placeholder="请输入联系人" />
      <van-field required label="联系电话" v-model="phone" type="tel" placeholder="请输入联系电话" />
      <van-field required label="联系邮箱" v-model="email" placeholder="请输入联系邮箱" />
      <van-field required v-model="message" rows="5" autosize label="情况简介" type="textarea" maxlength="500" placeholder="请详细描述实验室情况，方便我们更好的了解(10-500字)" show-word-limit/>
      <div class="btnImg">
        <div class="btn1 urlA" @click="sumbit">提交</div>
      </div>
      
      <van-overlay :show="show" @click="show = false">
        <div class="wrapper" @click.stop>
          <div class="block">
            <div class="msgbox">
              <img src="../../assets/joinusimg/xiaolian@2x.png">
              <p>信息提交成功，我们的工作人员会在第一时间进行审核，并在3个工作日内给您回电，请您留意接听电话。</p>
            </div>
            <div class="old-close" @click="closeOld"></div>
          </div>
        </div>
      </van-overlay>

    </div>
  </div>
</template>

<script>
import { joinus } from '@/api/resetApi.js'

export default {
  name: 'addjoin',
  inject: ['reload'],
  data(){
    return{
      company: '',
      person: '',
      phone: '',
      email: '',
      message: '',
      userid: '',
      type: '',
      show: false,
      ua: window.navigator.userAgent.toLowerCase(),
      browser: {
        trident: navigator.userAgent.indexOf('Trident') > -1, //IE内核
        presto: navigator.userAgent.indexOf('Presto') > -1, //opera内核
        webKit: navigator.userAgent.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
        gecko: navigator.userAgent.indexOf('Gecko') > -1 && navigator.userAgent.indexOf('KHTML') == -1, //火狐内核
        mobile: !!navigator.userAgent.match(/AppleWebKit.*Mobile.*/) || !!navigator.userAgent.match(/AppleWebKit/), //是否为移动终端
        ios: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Linux') > -1, //android终端或者uc浏览器
        iPhone: navigator.userAgent.indexOf('iPhone') > -1 || navigator.userAgent.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
        iPad: navigator.userAgent.indexOf('iPad') > -1, //是否iPad
        webApp: navigator.userAgent.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
      }
    }
  },
  created(){
    this.type = this.$route.query.type
    this.userid = this.$route.query.userid
  },
  methods: {
    openApp() {
      window.location = 'http://t.cn/Aijv8II4'
    },
    sumbit() {
      var regphone = /^1[3|4|5|6|7|8|9]\d{9}$/;
      var regemail = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
      if (this.company.length <= 0) {
        this.$createToast({
          txt: '请输入申请单位',
          type: 'error'
        }).show()
      } else if (this.person.length <= 0) {
        this.$createToast({
          txt: '请输入联系人',
          type: 'error'
        }).show()
      } else if (this.phone.length <= 0) {
        this.$createToast({
          txt: '请输入联系电话',
          type: 'error'
        }).show()
      } else if (!regphone.test(this.phone)) {
        this.$createToast({
          txt: '请输入正确的电话',
          type: 'error'
        }).show()
      } else if (this.email.length <= 0) {
        this.$createToast({
          txt: '请输入联系邮箱',
          type: 'error'
        }).show()
      } else if (!regemail.test(this.email)) {
        this.$createToast({
          txt: '请输入正确的邮箱',
          type: 'error'
        }).show()
      } else if (this.message.length <= 0) {
        this.$createToast({
          txt: '请详细描述实验室情况',
          type: 'error'
        }).show()
      } else if (this.message.length < 10) {
        this.$createToast({
          txt: '最少填写10个字',
          type: 'error'
        }).show()
      } else {
        console.log('成功')
        this.joinusinfo()
      }
    },
    async joinusinfo() {
      let qs = require('qs');
      let data = qs.stringify({
        unit: this.company, 
        user_name:  this.person,
        mobile: this.phone,
        email:  this.email,
        lab_info: this.message,
        type: this.type,
        user_id:  this.userid
      })
      const res = await joinus(data)
      console.log('res111111=',res)
      try {
        if (res.data.code === 1) {
          this.show = true
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },
    onClickLeft() {
      this.$router.back(-1)
    },
    closeOld() {
      this.show = false
      this.company = ''
      this.person = ''
      this.phone = ''
      this.email = ''
      this.message = ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 0;
}

.block {
  text-align: center;
  .msgbox {
    width: 300px;
    padding-bottom: 17px;
    background-color: #fff;
    border-radius: 10px;
    img {
      padding: 10px 0;
      width: 50px;
      height: 50px;
    }
    p {
      padding: 10px;
      line-height: 24px;
      text-align: left;
      font-size: 14px;
      color: #333;
      font-weight: 400;
    }
  }
  .old-close {
    display: inline-block;
    margin-top: 20px;
    width: 38px;
    height: 38px;
    background: url(../../assets/shareregimg/close.png);
  }
}
.btnImg{
  width:100%;
  height: 60px;
  padding-bottom: 10px;
}
.btn1 {
  width: 184px;
  margin: 30px auto 0px;
  display: block;
  text-align: center;
  background: -webkit-linear-gradient(left, #0097e0 , #004ea2); /* Safari 5.1 - 6.0 */
  // background: -o-linear-gradient(left, #0097e0, #004ea2); /* Opera 11.1 - 12.0 */
  // background: -moz-linear-gradient(left, #0097e0, #004ea2); /* Firefox 3.6 - 15 */
  // background: linear-gradient(left,#0097e0, #004ea2);
  padding: 15px 0;
  border-radius: 50px;
  font-size: 14px;
  color:#fff;
}
</style>
